"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUrl = exports.getUrlWithRegCodeParamMovedToStartOfQueryString = void 0;
var parse_url_1 = require("./parse-url");
Object.defineProperty(exports, "getUrlWithRegCodeParamMovedToStartOfQueryString", { enumerable: true, get: function () { return parse_url_1.getUrlWithRegCodeParamMovedToStartOfQueryString; } });
Object.defineProperty(exports, "parseUrl", { enumerable: true, get: function () { return parse_url_1.parseUrl; } });
